export function hashString(text) {
    return hashText(0x811c9dc5, text) >>> 0;
}
/** Folds `text` into a running FNV-1a state. */
function hashText(h, text) {
    for (let i = 0; i < text.length; i++) {
        h ^= text.charCodeAt(i);
        h = Math.imul(h, 0x01000193);
    }
    return h;
}
/**
 * Hashes a value's canonical JSON without building it: the same characters `stableStringify`
 * would emit are folded into the hash as they are produced, so the result equals
 * `hashString(stableStringify(value))` at a fraction of the allocation.
 */
function hashValue(h, value) {
    if (value === null || typeof value !== 'object') {
        return hashText(h, JSON.stringify(value) ?? 'null');
    }
    if (Array.isArray(value)) {
        h = hashText(h, '[');
        for (let i = 0; i < value.length; i++) {
            if (i > 0)
                h = hashText(h, ',');
            h = hashValue(h, value[i]);
        }
        return hashText(h, ']');
    }
    const record = value;
    const keys = Object.keys(record).sort();
    h = hashText(h, '{');
    let first = true;
    for (const key of keys) {
        const v = record[key];
        if (v === undefined)
            continue;
        if (!first)
            h = hashText(h, ',');
        first = false;
        h = hashText(h, JSON.stringify(key));
        h = hashText(h, ':');
        h = hashValue(h, v);
    }
    return hashText(h, '}');
}
/** JSON with object keys in sorted order; `undefined` members are skipped like JSON.stringify. */
export function stableStringify(value) {
    if (value === null || typeof value !== 'object') {
        return JSON.stringify(value) ?? 'null';
    }
    if (Array.isArray(value)) {
        let out = '[';
        for (let i = 0; i < value.length; i++) {
            if (i > 0)
                out += ',';
            out += stableStringify(value[i]);
        }
        return `${out}]`;
    }
    const record = value;
    const keys = Object.keys(record).sort();
    let out = '{';
    let first = true;
    for (const key of keys) {
        const v = record[key];
        if (v === undefined)
            continue;
        if (!first)
            out += ',';
        first = false;
        out += `${JSON.stringify(key)}:${stableStringify(v)}`;
    }
    return `${out}}`;
}
/** Canonical JSON of the state minus the per-tick events (which are derived, not state). */
export function canonicalState(state) {
    return stableStringify({ ...state, events: undefined });
}
export function hashMatchState(state) {
    return hashValue(0x811c9dc5, { ...state, events: undefined }) >>> 0;
}
//# sourceMappingURL=hash.js.map